import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

const AUTO_MARGIN = 'auto'

export const AppOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 350px;
  margin-right: ${AUTO_MARGIN};
  margin-bottom: ${Spacing.S32};
  margin-left: ${AUTO_MARGIN};
`

export const AppIllustration = styled.img`
  height: 40px;
`
